
import {
  computed, defineComponent, onMounted, PropType,
} from 'vue';
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import {
  RCS_AVERAGE_GLOBAL_TRAFFIC,
  RCS_AVERAGE_MESSAGE_RATE_PER_USER,
  RCS_USERS_TARGETED,
  applyCarrierHiddenDefaults,
  createEmptyPointOfContact,
} from '@/types/rcs-onboarding';
import type { RcsDedicatedFormState } from '@/types/rcs-onboarding';

export default defineComponent({
  name: 'RcsCarrierRequirementsStep',

  components: {
    InputText,
    Dropdown,
  },

  props: {
    form: {
      type: Object as PropType<RcsDedicatedFormState>,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const carrier = computed(() => props.form.carrier_requirements);

    const buildEnumOptions = (prefix: string, values: readonly string[]) => values.map(
      (value) => ({
        label: t(`storeParameters.services.rcsServiceParameter.wizard.carrier.enums.${prefix}.${value}`),
        value,
      }),
    );

    const averageGlobalTrafficOptions = computed(() => buildEnumOptions(
      'averageGlobalTraffic',
      RCS_AVERAGE_GLOBAL_TRAFFIC,
    ));

    const messageRateOptions = computed(() => buildEnumOptions(
      'averageMessageRatePerUser',
      RCS_AVERAGE_MESSAGE_RATE_PER_USER,
    ));

    const usersTargetedOptions = computed(() => buildEnumOptions(
      'usersTargeted',
      RCS_USERS_TARGETED,
    ));

    const addContact = () => {
      carrier.value.points_of_contact.push(createEmptyPointOfContact());
    };

    const removeContact = (index: number) => {
      carrier.value.points_of_contact.splice(index, 1);
    };

    onMounted(() => {
      applyCarrierHiddenDefaults(props.form.carrier_requirements);
    });

    return {
      t,
      carrier,
      averageGlobalTrafficOptions,
      messageRateOptions,
      usersTargetedOptions,
      addContact,
      removeContact,
    };
  },
});
